define('formkit/view/form.object/content/information.content.view',['require','exports','module','underscore','./base.content.view'],function (require, exports, module) {
  var _               = require('underscore');
  var BaseContentView = require('./base.content.view');

  var InformationContentView = BaseContentView.extend({
    options: _.extend({}, BaseContentView.prototype.options, {
      hasAnswer: false
    })
  });

  module.exports = InformationContentView;
});

